import React, { createContext, useCallback, useContext, useState } from 'react';
export type Role = 'customer' | 'admin';
export interface Session {
  username: string;
  name: string;
  email: string;
  role: Role;
}

/** Demo credentials. Real auth would never live in the client. */
const demoAccounts: Record<string, {
  password: string;
  session: Session;
}> = {
  user: {
    password: 'user123',
    session: {
      username: 'user',
      name: 'Priya Raman',
      email: 'priya@acme.com',
      role: 'customer'
    }
  },
  admin: {
    password: 'admin123',
    session: {
      username: 'admin',
      name: 'Dev Ramachandran',
      email: 'dev@watchtowerworks.com',
      role: 'admin'
    }
  }
};
interface AuthValue {
  session: Session | null;
  signIn: (username: string, password: string) => Session | null;
  signOut: () => void;
}
const AuthContext = createContext<AuthValue | null>(null);
export function AuthProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [session, setSession] = useState<Session | null>(null);
  const signIn = useCallback((username: string, password: string) => {
    const account = demoAccounts[username.trim().toLowerCase()];
    if (!account || account.password !== password) {
      return null;
    }
    setSession(account.session);
    return account.session;
  }, []);
  const signOut = useCallback(() => setSession(null), []);
  return <AuthContext.Provider value={{
    session,
    signIn,
    signOut
  }} data-id="element-519" data-mp="2giu87sof0ezb">
      {children}
    </AuthContext.Provider>;
}
export function useAuth(): AuthValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used inside AuthProvider');
  }
  return context;
}